import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  metaMaskWallet,
  injectedWallet,
  rainbowWallet,
  coinbaseWallet,
  walletConnectWallet,
  trustWallet,
  ledgerWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { mainnet } from 'wagmi/chains';
import { http } from 'wagmi';

export const config = getDefaultConfig({
  appName: 'Pepe\'s Dog Army',
  projectId: '2e7f74f9ce3e956d379731c703c5bfe8',
  chains: [mainnet],
  ssr: false,
  transports: {
    [mainnet.id]: http('https://eth-mainnet.g.alchemy.com/v2/Qlq-ZWuGB_BAdRKBjJoebHdcE2W-d9kX'),
  },
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [
        metaMaskWallet,
        rainbowWallet,
        coinbaseWallet,
        walletConnectWallet,
        trustWallet,
        ledgerWallet,
      ],
    },
    {
      groupName: 'Other',
      wallets: [injectedWallet],
    },
  ],
});
